export enum NangoIntegrationType {
  Jira = "jira",
}
